import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import useOnboardingStatus from '../../hooks/useOnboardingStatus';

const OnboardingStep = ({ title, subtitle, linkTo, linkLabel, completed }) => (
    <div className={`priority-card ${completed ? 'accent-muted' : 'accent-green'}`}>
        <div className="action-row">
            <div>
                <h3
                    style={{
                        fontFamily: "'New Amsterdam', sans-serif",
                        fontSize: '1.3rem',
                        letterSpacing: '1px',
                        color: completed ? '#78716c' : '#212529',
                        margin: 0,
                    }}
                >
                    {completed && <FontAwesomeIcon icon={faCheck} style={{ marginRight: 8, color: '#17CA07' }} />}
                    {title}
                </h3>
                <div className="action-detail">{subtitle}</div>
            </div>
            {!completed && (
                <Link to={linkTo} className="card-cta green">
                    {linkLabel}
                </Link>
            )}
        </div>
    </div>
);

const OnboardingView = () => {
    const { steps } = useOnboardingStatus();

    return (
        <>
            <OnboardingStep
                title="Build Your First Team"
                subtitle="Pick your 24-man roster and set a batting order."
                linkTo="/team/create"
                linkLabel="Build Team"
                completed={steps.hasTeam}
            />
            <OnboardingStep
                title="Beat the Tutorial for a Free Gold Pack"
                subtitle="Play your first game against an easy team and earn a gold pack full of high-rated cards."
                linkTo="/campaigns"
                linkLabel="Play Now"
                completed={steps.beatTutorial}
            />
        </>
    );
};

export default OnboardingView;
